import type { IRParam, IRValue } from '../types/ir';
import { evaluateExpression } from '../logic/engine.ir';

export function humanizeParamName(name: string): string {
  const spaced = name.replace(/_/g, ' ').trim();
  if (spaced.length === 0) return spaced;
  return spaced[0].toUpperCase() + spaced.slice(1);
}

export function paramDisplayLabel(param: IRParam): string {
  return param.label ?? humanizeParamName(param.name);
}

export function defaultValueFor(param: IRParam): IRValue {
  return evaluateExpression(param.default, {});
}

export function defaultsForAll(params: IRParam[]): Record<string, IRValue> {
  const out: Record<string, IRValue> = {};
  for (const p of params) out[p.name] = defaultValueFor(p);
  return out;
}
